
import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import { Box, Button, Grid, TextField, IconButton, FormControl, Select, MenuItem, InputLabel } from '@material-ui/core'; //Grid, Paper,

import {MoreVert} from '@material-ui/icons';
import {HighlightOff} from '@material-ui/icons';

import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDateTimePicker} from '@material-ui/pickers';
import { getDateTimeFormat } from '../../../../functions/lang';
import { SelectUserDialog } from '../SelectUserDialog';


class ReportConnectDisconnectFilter_ extends React.Component {

    constructor() {
        super()

        this.state = {
            selectUserDialog:{
                open: false,
                userID: null
            }
        }

        this.handleDateFromChange = this.handleDateFromChange.bind(this)
        this.handleDateToChange = this.handleDateToChange.bind(this)

        this.handleApplyFilter = this.handleApplyFilter.bind(this)
        this.handleAction = this.handleAction.bind(this)

    }

    handleDateFromChange(date){
        let filter = {...this.props.filter}
        filter.dateFrom = date
        console.log('handleDateFromChange')
        console.log(date)

        //this.setState({dateFrom: date})
        //if(this.props.onChange) this.props.onChange(filter)
        
        this.props.onAction({type: 'FILTER_CHANGE', filter: filter})
        
    }

    handleDateToChange(date){
        let filter = {...this.props.filter}
        //this.setState({dateTo: date})
        filter.dateTo = date
        console.log('handleDateToChange')
        console.log(date)

        //if(this.props.onChange) 
        this.props.onAction({type: 'FILTER_CHANGE', filter: filter})//
        
    }

    handleChange(e){
        console.log('handleChange event')
        console.log(e)

        let filter = {...this.props.filter}
        filter[e.target.name] = e.target.value
        this.props.onAction({type: 'FILTER_CHANGE', filter: filter})//
    }

    handleApplyFilter(){
        this.props.onAction({type:'FILTER_APPLY', filter: this.props.filter})
    }

    handleAction(action){

        switch(action.type){
            case 'SELECT_USER_DIALOG_OPEN':{
                let selectUserDialog = this.state.selectUserDialog
                selectUserDialog.open = true
                this.setState({selectUserDialog: selectUserDialog})
                break
            }

            case 'SELECT_USER_DIALOG_SELECT':{
                let selectUserDialog = this.state.selectUserDialog
                selectUserDialog.open = false

                let filter = {...this.props.filter, user: action.user, userID: action.userID}
                this.props.onAction({type: 'FILTER_CHANGE', filter: filter})

                this.setState({selectUserDialog: selectUserDialog})
                break
            }

            case 'SELECT_USER_DIALOG_CLOSE':{
                let selectUserDialog = this.state.selectUserDialog
                selectUserDialog.open = false
                this.setState({selectUserDialog: selectUserDialog})
                break
            }

            case 'CLEAR_USER':{
                let filter = {...this.props.filter, user:'', userID: null}
                this.props.onAction({type: 'FILTER_CHANGE', filter: filter})
                break
            }

            default: {
                alert(action.type)
            }

        }

    }


    render(){
        const {t, i18n} = this.props

        let dateFormat = getDateTimeFormat(i18n)

        const style = {
            label: {
                padding: '22px 10px 5px 5px',
                display: 'inline-block'
            },
            datepicker:{
                width:180,
                marginRight: 16,
                marginTop: 0
            },
            select:{
                width:150,
                marginRight:10
            },
            itemSelect:{
                width:250, marginRight:10
            }
        }

        //console.log('this.props.networks')
        //console.log(this.props.networks)

        return(
            <MuiPickersUtilsProvider utils={DateFnsUtils}>

            {this.state.selectUserDialog.open? (
                    <SelectUserDialog open={this.state.selectUserDialog.open}
                        networks={this.props.networks}
                        networkID={this.props.filter.networkID}
                        onAction={this.handleAction} ></SelectUserDialog>
                ) : null }


            <Box style={{margin: '0 16px', paddingTop:8}}>


                <FormControl style={style.select}>
                    <InputLabel htmlFor="networkID">{t("Network")}</InputLabel>
                    <Select
                        label="network"
                        style={{textAlign: 'left'}}
                        value={this.props.filter.networkID}
                        onChange={this.handleChange.bind(this)}
                        inputProps={{name: 'networkID', id: 'networkID'}}
                        >
                        {this.props.networks.map(
                            network => <MenuItem key={network.ID} value={network.ID}>{network.Name}</MenuItem>
                        )}
                    </Select>
                </FormControl>

                <KeyboardDateTimePicker
                    style={style.datepicker}
                    margin="normal"
                    id="dateFrom"
                    name="dateFrom"
                    label={t('From')}
                    cancelLabel={t('Cancel')}
                    okLabel={t('Apply')}
                    format={dateFormat}
                    value={this.props.filter.dateFrom}
                    onChange={this.handleDateFromChange}
                    KeyboardButtonProps={{'aria-label': 'change date'}}
                />

                <KeyboardDateTimePicker
                    style={style.datepicker}
                    margin="normal"
                    id="dateTo"
                    name="dateTo"
                    label={t("To")}
                    cancelLabel={t('Cancel')}
                    okLabel={t('Apply')}
                    format={dateFormat}
                    value={this.props.filter.dateTo}
                    onChange={this.handleDateToChange}
                    KeyboardButtonProps={{'aria-label': 'change date'}}
                />          

                <FormControl style={style.itemSelect}>
                    <Grid container>
                        <Grid item xs={9} align="left">
                            <TextField
                            name="user"
                            id="user"
                            onChange={()=>{this.handleAction({type: 'SELECT_USER_DIALOG_OPEN'})}}
                            label={t("UserName")}
                            value={this.props.filter.user}
                            style={{width:'100%'}}
                        />
                        </Grid>
                        <Grid item xs={3} style={{verticalAlign:'bottom', paddingTop:18}}>
                            <IconButton
                                size="small" color="inherit" aria-label="more edit" component="span"
                                onClick={()=>{this.handleAction({type: 'SELECT_USER_DIALOG_OPEN'})}}>
                                <MoreVert />
                            </IconButton>
                            <IconButton disabled={!this.props.filter.user} 
                                size="small" color="inherit" aria-label="clear" component="span"
                                onClick={()=>{this.handleAction({type: 'CLEAR_USER'})}}>
                                <HighlightOff/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </FormControl>

                <Button style={{margin:8}} 
                    variant="outlined" 
                    onClick={this.handleApplyFilter}>{t('Apply')}</Button>

            </Box>
            </MuiPickersUtilsProvider>
        );

    }

}

export const ReportConnectDisconnectFilter = withTranslation()(ReportConnectDisconnectFilter_);

